import { FalloutCharacter, FalloutCharacterStatus } from "../Data/Response";
import EnemyTargetView, { Target } from "./EnemyTargetView";


type SelectTargetArgs = {
    enemyTargets: FalloutCharacter[];
    setTarget: (target: Target) => void;
}

const SelectTargetView: React.FC<SelectTargetArgs> = (args) => {
    return <div>
        <h2>Select enemy target.</h2>
        <ul>
            {args.enemyTargets.filter(t => t.state.status === "active").map(pc => {
                return <EnemyTargetView playerCharacter={pc} setTarget={args.setTarget} />
            })}
        </ul>
    </div>
}

export default SelectTargetView;